(() => {
  // Enhance only retained policy content; never replace legal text or touch other pages.
  document.querySelectorAll('.hc-refund-policy').forEach((policy) => {
    const label = policy.querySelector('.hc-policy-label');
    policy.querySelectorAll('.hc-policy-nav').forEach((navigation) => {
      // Restore navigation semantics from the existing localized policy label.
      navigation.setAttribute('role', 'navigation');
      if (label) navigation.setAttribute('aria-label', label.textContent.trim());
    });
    policy.querySelectorAll('div.hc-policy-mobile-nav:not(.hc-policy-enhanced)').forEach((source) => {
      // Move the existing localized label into a native keyboard-operable disclosure.
      const heading = source.querySelector('.hc-policy-toggle');
      if (!heading) return;
      const details = document.createElement('details');
      const summary = document.createElement('summary');
      details.className = source.className;
      details.classList.add('hc-policy-enhanced');
      summary.append(...heading.childNodes);
      // Reuse the existing chevron-family geometry; all visual styling stays in CSS.
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      svg.setAttribute('viewBox', '0 0 11.38 6.13');
      svg.setAttribute('aria-hidden', 'true');
      path.setAttribute('d', 'M.13.13c.17-.17.45-.17.62,0,0,0,0,0,0,0l4.94,4.94L10.64.13c.17-.17.45-.17.62,0s.17.45,0,.62l-5.25,5.25c-.17.17-.45.17-.62,0,0,0,0,0,0,0L.13.75c-.17-.17-.17-.45,0-.62,0,0,0,0,0,0');
      svg.append(path);
      summary.append(svg);
      // Preserve all original nodes and keep terms outside the initially closed details.
      source.replaceChild(summary, heading);
      details.append(...source.childNodes);
      source.replaceWith(details);
    });
  });
})();
